import { render, staticRenderFns } from "./ArrowsSeal.vue?vue&type=template&id=1fdedad0"
import script from "./ArrowsSeal.vue?vue&type=script&lang=js"
export * from "./ArrowsSeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports